<template>
  <footer id="footer">
    <div class="footer-content">
      <div class="footer-text">
        <p class="footer-line">
          <a href="https://www.creditchina.gov.cn/" target="_blank" class="footer-link">
            友情链接：信用中国 信用中国（安康）
          </a>
        </p>
        <p class="footer-line">主办单位：安康市金融工作办公室 中国人民银行安康市分行</p>
        <p class="footer-line">承办单位：安康市企业信用服务有限公司</p>
        <p class="footer-line">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="footer-link">
            备案号：陕ICP备2022009839号-2
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {};
  },
};
</script>

<style scoped>
#footer {
  width: 100%;
  height: 160px;
  background-color: #183874;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-content {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1500px;
  /* padding: 45px 0 45px 0; */
}

.footer-text {
  text-align: left;
}

.footer-line {
  font-family: "PingFang SC", sans-serif;
  font-size: 14px;
  line-height: 35px;
  letter-spacing: 0.0375em;
  color: #ffffff;
  margin: 0;
}

.footer-link {
  color: #ffffff;
  /* text-decoration: underline; */
  transition: opacity 0.3s;
}

.footer-link:hover {
  opacity: 0.8;
}
</style>
